module.exports = __webpack_public_path__ + "img/point-4@2x.07d29536.jpg";